export default __webpack_public_path__ + "static/media/very-low.248b985c.svg";